import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LoaderService } from '../../services/loader.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	standalone: false,
	selector: 'bt-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
	@Input() public loaderId: string;
	readonly #destroyRef = inject(DestroyRef);
	readonly #loaderService = inject(LoaderService);

	public inLoading: boolean;
	public withContent: boolean;

	public ngOnInit() {
		if (this.loaderId) {
			this.#loaderService
				.createLoader(this.loaderId)
				.pipe(
					filter((x) => !!x),
					takeUntilDestroyed(this.#destroyRef)
				)
				.subscribe((data) => {
					this.inLoading = data.show;
					setTimeout(() => {
						const el = document.getElementById(this.loaderId);
						this.withContent = data.show && !!el && !!el.nextElementSibling;
					});
				});
		}
	}

	public ngOnDestroy() {
		this.#loaderService.destroyLoader(this.loaderId);
	}
}
